import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../context/LanguageContext";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../styles/LayoutStyles";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import { StyledInput } from "../../../styles/InputStyles";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import FormContainer from "../../../components/formContainer/FormContainer";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import TranslationsDataTable from "../../../components/dataTable/tables/TranslationsDataTable";
import Select from "../../../components/select/main/Select";

//The selectable date and time formats (PHP date() notation, must match the Language model on the backend)
const DATE_FORMATS = ["Y-m-d", "d-m-Y", "d/m/Y", "d.m.Y", "m/d/Y"];
const TIME_FORMATS = ["H:i", "h:i A"];

/**
 * This method will return an example of the given PHP date format (31 January 2026 14:30)
 * @param {string} format
 * @returns {string}
 */
function formatExample(format) {
  const parts = {
    d: "31",
    m: "01",
    Y: "2026",
    H: "14",
    h: "02",
    i: "30",
    A: "PM",
  };
  return format
    .split("")
    .map((character) => parts[character] ?? character)
    .join("");
}

function LanguagePageView({
  languageData,
  onCodeChange,
  onLabelChange,
  onDateFormatChange,
  onTimeFormatChange,
  onCancel,
  onSubmit,
  submitError,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
      <OverlayLoader groups="language_page_fetch">
        <FormContainer
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitError={submitError}
          submitLoadingGroup={"language_page_save"}
        >
          <StyledFlexRow
            style={{ margin: `0px 0px ${theme.spacing.normal} 0px` }}
          >
            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.code")}
                error={EVAApiHelper.getResponseError("code", submitError)}
                required
              >
                <StyledInput
                  type="text"
                  value={languageData.code}
                  placeholder={translate(
                    "eva.main.validation.placeholders.code.language"
                  )}
                  onChange={onCodeChange}
                  disabled={languageData.default}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.label")}
                error={EVAApiHelper.getResponseError("label", submitError)}
                required
              >
                <StyledInput
                  type="text"
                  value={languageData.label}
                  placeholder={translate(
                    "eva.main.validation.attributes.label"
                  )}
                  onChange={onLabelChange}
                  disabled={languageData.default}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>

          <StyledFlexRow
            style={{ margin: `0px 0px ${theme.spacing.normal} 0px` }}
          >
            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.date_format")}
                error={EVAApiHelper.getResponseError(
                  "date_format",
                  submitError,
                )}
                required
              >
                <Select
                  options={DATE_FORMATS.map((format) => {
                    return { value: format, label: formatExample(format) };
                  })}
                  value={languageData.date_format}
                  onChange={onDateFormatChange}
                />
              </InputWrapper>
            </StyledFlexItem>

            <StyledFlexItem>
              <InputWrapper
                label={translate("eva.main.validation.attributes.time_format")}
                error={EVAApiHelper.getResponseError(
                  "time_format",
                  submitError,
                )}
                required
              >
                <Select
                  options={TIME_FORMATS.map((format) => {
                    return { value: format, label: formatExample(format) };
                  })}
                  value={languageData.time_format}
                  onChange={onTimeFormatChange}
                />
              </InputWrapper>
            </StyledFlexItem>
          </StyledFlexRow>
        </FormContainer>
      </OverlayLoader>

      {languageData.fetched ? (
        <TranslationsDataTable languageData={languageData} />
      ) : (
        ""
      )}
    </StyledFlexColumn>
  );
}

export default LanguagePageView;
